import firebase from 'firebase/app'
import { auth } from '@/providers/firebase'
const provider = new firebase.auth.GoogleAuthProvider()

export const doLoginFlow = () => {
  return new Promise((resolve, reject) => {
    auth
      .signInWithPopup(provider)
      .then(result => {
        resolve(result)
      })
      .catch(err => {
        reject(err)
      })
  })
}
